<template>
    <b-modal id="modal_form"
             ref="modal_form"
             :title="modal_titulo"
             :ok-title="modal_botao"
             close-title="Fechar"
             cancel-title="Cancelar"
             :ok-disabled=form.errors.any()
             v-model="showModal"
             @ok="handleOk">

        <form @submit.stop.prevent="handleOk"
              @keydown="form.errors.clear($event.target.name)">
            <label>Nome do país</label>
            <b-form-input type="text"
                          placeholder="Nome do país"
                          v-model="form.nome"
                          name="nome">
            </b-form-input>
            <b-form-feedback v-text="form.errors.get('nome')" v-if="form.errors.has('nome')"></b-form-feedback>

            <label>Código BACEN</label>
            <b-form-input type="text"
                          placeholder="Código BACEN"
                          v-model="form.cd_bacen"
                          name="cd_bacen">

            </b-form-input>
            <b-form-feedback v-text="form.errors.get('cd_bacen')"
                             v-if="form.errors.has('cd_bacen')"></b-form-feedback>

            <label>Código ISO</label>
            <b-form-input type="text"
                          placeholder="Código ISO"
                          v-model="form.cd_iso"
                          name="cd_iso">
            </b-form-input>
            <b-form-feedback v-text="form.errors.get('cd_iso')"
                             v-if="form.errors.has('cd_iso')"></b-form-feedback>

            <label>Nome da Nacionalidade</label>
            <b-form-input type="text"
                          placeholder="Código Nacionalidade"
                          v-model="form.cd_nac"
                          name="cd_nac">
            </b-form-input>
            <b-form-feedback v-text="form.errors.get('cd_nac')"></b-form-feedback>

            <label>Código ERP</label>
            <b-form-input type="text"
                          placeholder="Código ERP"
                          v-model="form.cd_opentech"
                          name="cd_opentech">
            </b-form-input>
            <b-form-feedback v-text="form.errors.get('cd_opentech')" v-if="form.errors.has('cd_opentech')"></b-form-feedback>

            <label>Status</label>
            <b-form-group>
              <b-form-radio-group
                v-model="form.status"
                :options="optionsLivStatus"
                name="status"
                stacked
                plain
              ></b-form-radio-group>
            </b-form-group>
            <b-form-feedback v-text="form.errors.get('status')"  v-if="form.errors.has('status')"></b-form-feedback>

        </form>

        <div slot="modal-footer" class="w-100">
            <div class="float-left">
                <spinner v-if="loading" message="Processando..."></spinner>
            </div>
            <div class="float-right">
                <AvisoErros v-bind:errors_array="errors_array"></AvisoErros>
                <b-btn @click="showModal=false" variant="secondary">
                    Fechar
                </b-btn>
                <b-btn @click="handleOk($event)" variant="secondary" :disabled="isDisabled">
                    Enviar
                </b-btn>
            </div>
        </div>
    </b-modal>
</template>
<script>
import AvisoErros from '../components/AvisoErros'


export default {
components: {
    AvisoErros,
},
props: {
    metodo: {type: Function},
    tabela: '',
    rota: ''
},
data () {
    return {
      errors_array: [],
      dataExport: [],
      modal_titulo: '',
      modal_botao: '',
      modal_acao: '',
      loading: false,
      isDisabled: false,
      loadingData: true,
      showModal: false,
      isFullscreen: false,
      optionsLivStatus: [],
      form: new Form({
          nome: '',
          cd_bacen: '',
          cd_iso: '',
          cd_opentech: '',
          cd_nac: '',
          pais_id: '',
          status: 1
                   }),
     helpForm: new Form({statusRecord: [], params: []}),
    fields: [
      {
          name: '__checkbox',
          titleClass: 'center aligned',
          dataClass: 'center aligned'
      },
      {
        name: 'cd',
        title: 'Código',
        sortField: 'cd'
      },
      {
        name: 'descr',
        title: 'Descrição',
        sortField: 'descr'
      },
      {
        name: '__slot:status',
        title: 'Status',
        sortField: 'status'
      },
      {
          name: '__slot:actions',   // <----
          title: 'Ações',
          titleClass: 'center aligned',
          dataClass: 'center aligned'
      }
  ],
  css: {
      loadingClass: 'loading',
      ascendingIcon: 'glyphicon glyphicon-chevron-up',
      descendingIcon: 'glyphicon glyphicon-chevron-down',
      handleIcon: 'glyphicon glyphicon-menu-hamburger',
  },
  moreParams: {}
   }
},
mounted() {
    this.getLivStatus();
  },
methods: {
    handleOk(e)
    {
        e.preventDefault();
        if(this.modal_acao=="i")
        {
           this.onStore();
        }
        else
        {
            this.onUpdate(this.form.pais_id);
        }
    },
    onCreate ()
    {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Cadastrar";
      this.modal_botao = "Cadastrar";
      this.modal_acao = "i";
      this.form.reset();
      this.errors_array = '';
      this.errors_array = [];
      this.form.status = 1;
      this.$refs.modal_form.show();
    },
    onEdit (data, index, id)
    {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Alterar";
      this.modal_botao = "Alterar";
      this.modal_acao = "u";
      this.form.reset();
      this.errors_array = '';
      this.errors_array = [];
      this.form.cd_bacen = data.cd_bacen;
      this.form.cd_opentech = data.cd_opentech;
      this.form.nome = data.nome;
      this.form.status = data.status.valor;
      this.form.cd_opentech = data.cd_opentech;
      this.form.cd_integracao = data.cd_integracao;
      this.form.cd_nac = data.cd_nac;
      this.form.cd_iso = data.cd_iso;
      this.form.pais_id = id;
      this.$refs.modal_form.show();
    },
    onStore()
    {
        this.loading = true;
        this.isDisabled = true;
        this.form.put('/api/'+this.rota+'/store').then(response =>
        {
            new ReturnApi(response, this)
            if(this.metodo!=null)
            {
               this.metodo();
            }
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this, true, null, null, false);
            this.errors_array = '';
            this.errors_array = [];
            for (var property in errors) {
              if (errors.hasOwnProperty(property)) {
                if (typeof(errors[property]) === 'object') {
                  errors[property].forEach((obj) => {
                    this.errors_array.push({
                      erro: obj
                    });
                  });
                }
              }
            }
        });
    },
    onUpdate(id)
    {
        this.loading = true;
        this.isDisabled = true;
        this.form.patch('/api/'+this.rota+'/update/'+id).then(response =>
        {
            new ReturnApi(response, this)
            if(this.metodo!=null)
            {
               this.metodo();
            }
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this, true, null, null, false);
            this.errors_array = '';
            this.errors_array = [];
            for (var property in errors) {
              if (errors.hasOwnProperty(property)) {
                if (typeof(errors[property]) === 'object') {
                  errors[property].forEach((obj) => {
                    this.errors_array.push({
                      erro: obj
                    });
                  });
                }
              }
            }
        });
    },
    onActivateDesactivate(helpForm)
    {
        helpForm.patch('/api/'+this.rota+'/status').then(response =>
        {
            new ReturnApi(response, this)
            if(this.metodo!=null)
            {
               this.metodo();
            }
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this, true, null, null, false);
            this.errors_array = '';
            this.errors_array = [];
            for (var property in errors) {
              if (errors.hasOwnProperty(property)) {
                if (typeof(errors[property]) === 'object') {
                  errors[property].forEach((obj) => {
                    this.errors_array.push({
                      erro: obj
                    });
                  });
                }
              }
            }
        });

    },
    getLivStatus()
    {
        this.helpForm.params = { tabela: this.tabela,
                                coluna: 'status' };

        this.helpForm.get('/api/listitemvalor/jsonlist').then(response =>
        {
            new ReturnApi(response, this, true, false, false);
            response.items.forEach((obj)=>
            {
                this.optionsLivStatus.push({ text: obj.descr, value: obj.valor })
            })
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this, true, null, null, false);
            this.errors_array = '';
            this.errors_array = [];
            for (var property in errors) {
              if (errors.hasOwnProperty(property)) {
                if (typeof(errors[property]) === 'object') {
                  errors[property].forEach((obj) => {
                    this.errors_array.push({
                      erro: obj
                    });
                  });
                }
              }
            }
        });
    },
    onError(response) {
        new ReturnApi(response.response, this, true, true, false);
    },
    getPermission(checkPermission) {
        return this.getPermissionFw(checkPermission);
    },
},
computed: {
    vuetableFilterRow: {
      get () {
        return this.$store.state.vuetable.filterRow;
      },
    },
    isLoaded: {
        get() {
            return this.$store.getters.isloaded;
        }
    }
}
}
</script>
